module.exports = __webpack_public_path__ + "img/flowers-right-horizontal.186d2f04.png";